import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import 'chosen-js/chosen.css';
import chosen from 'chosen-js/chosen.jquery';

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';


const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class GeneralExpenses extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);
		this.getNationalCenter = this.getNationalCenter.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],
			index:-1,

			loadHealth:false,

			start_date 	: "",
			end_date 	: "",

			listado:[],
			national_centers:[{national_center:{id:'all', name:'TODOS'}}],
			national_center_id:"",
			index_nc:-1,

			columns:[
				{title:'Folio Salida', width:'100px'},
				{title:'F. Salida', width:'100px'},
				{title:'Unidad', width:'100px'},
				{title:'Hospital origen', width:'200px'},
				{title:'Paciente', width:'250px'},
				{title:'Hospital Destino', width:'300px'},
				{title:'No. Solicitud', width:'100px'},
				{title:'T. Salida', width:'100px'},
				{title:'Comp', width:'100px'},
				{title:'Responsable Entrega', width:'250px'},
				{title:'F. Cancelación', width:'100px'},
				{title:'Usuario Cancelo', width:'250px'}
			],
			filename:"Egresos Generales",
			date_hour:"",
			totales:"",
			origin_disabled:false,

			option:["all"],
			options:[
				{key:'patients', value:'Pacientes'},
				{key:'hemored', value:'Hemored'},
				{key:'externo', value:'Externos'},
				{key:'discard', value:'Baja'},
				{key:'plasma', value:'Plasma'},
			],
			status:"all",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		if(sessionStorage.getItem('health_facilities_id') !== sessionStorage.getItem('matriz')){
			this.setState({
				health_facilities_id:sessionStorage.getItem('health_facilities_id'),
				origin_disabled:true
			});
		}


		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				response.unshift({id:'all', name:'TODOS'});
				this.setState({
					health_facilities: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		this.setTable();
	}

	getNationalCenter(id){
		fetch(Config.default.apiGateway.URL+'national_centers/exclude_itsame?health_facilities_id='+id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			response.unshift({national_center:{id:'all', name:'TODOS'}});
			this.setState({national_centers: response});
		});
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas+'\t\t\t'+this.state.medical, margin:[10,0,0,10] });

                		doc.content[4] = {
							text:'Total: '+this.state.totales,
							margin:[5,15,0,0]
            			}

            			//doc.content[3].table.widths = ['6%','8%','5%','15%','15%','15%','5%','10%','8%', '13%'];
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; //2,3,4,etc doc.styles.tableHeader.fontSize = 1; //2, 3, 4, etc 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:false,
			info:false,
			
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'option'){
			var options = e.target.options;
			
			var value = [];
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push('all');
			    		break;
			    		
			    	}else{
			    		value.push(options[i].value);
			    	}
			    }
			}

			this.setState({
				[e.target.name]: value
			});

			this.$select.val(value).trigger("chosen:updated");
		}else{
			this.setState({
				[e.target.name]: e.target.value
			});

			if(document.getElementById(e.target.name).className.includes('error')){
				document.getElementById(e.target.name).classList.remove('error');
			}
		}
			
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){

				this.props.waiting.handleShow('Buscando...');

				var object = {};
				object.start_date = this.state.start_date;
				object.end_date = this.state.end_date;
				object.national_center_id = this.state.national_center_id;
				object.health_facilities_id = this.state.health_facilities_id;
				object.status = this.state.status;

				var options = [];
				if(this.state.option[0] === 'all'){
					this.state.options.map((l)=>{
						return options.push(l.key);
					});
				}else{
					options = this.state.option;
				}

				object.options_array = options;

				
				fetch(Config.default.apiGateway.URL+'reports/general_expenses', {
					method : 'post',
					body:JSON.stringify(object),
					responseType: 'blob', //Force to receive data in a Blob Format
					headers : new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
						'Content-Type': 'application/json'
					})
				})
				.then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				})
				.then(response => {
					if(response !== undefined){
						var list = [];

						response.res.map((res, i)=>{
							list.push([
								res.folio,
								moment(res.date).format('DD/MM/YYYY HH:mm'),
								res.unit_number,
								res.origin,
								res.patient,
								res.final_center,
								res.petition_number,
								res.type,
								res.code,
								res.user_send,
								res.cancel_timestamp !== null ?
									moment(res.cancel_timestamp).format('DD/MM/YYYY')
								: '',
								res.user_cancel
							]);
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							totales:response.count
						});
					}
					
						
				})
				

				
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	_handleSearch = (e)=>{
		console.log(e)
	}

	updateState = name => e=>{
		if(e.length > 0){

			if(name === 'health_facilities'){
				var index = this.state.health_facilities.findIndex(obj => 
					obj.id === e[0].id
				);

				this.setState({health_facilities_id:e[0].id, index:index});

				if(e[0].id !== 'all'){
					this.getNationalCenter(e[0].id);	
				}else{
					this.setState({index_nc:0, national_center_id:'all'})
				}

				
			}else{
				var index = this.state.national_centers.findIndex(obj => 
					obj.national_center.id === e[0].national_center.id
				);

				this.setState({national_center_id:e[0].national_center.id, index_nc:index});
				
			}
		}
	}

	render(){
		$('#health_id').addClass('autocomplete-report');
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Distribución ->
					{this.state.filename}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_distribution"} 
		            submenu={"help_general_expenses"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro Origen</span>
									<AsyncTypeahead
							          	labelKey={(option) => `${option.name}`}
							          	minLength={0}
							          	name="health_id"
							          	id="health_id"
							          	inputProps={{
							          		name:"health_facilities_id",
							          		required: true,
							          		id:"health_facilities_id",
							          		autoComplete:"off",
							          	}}
							          	className="autocomplete-report"
							          	onSearch={this._handleSearch}
							          	placeholder="Búsqueda..."
							          	options={this.state.health_facilities}
							          	onChange={this.updateState('health_facilities')}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.loadHealth}
							          	selectHintOnEnter={true}
							          	//defaultSelected={this.state.health_facilities.slice(this.state.index, 1)}
							          	selected={this.state.health_facilities.length > 0 && this.state.index !== -1?
							          		[this.state.health_facilities[this.state.index]]
							          		: []}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>
								<div className="form-group">
									<span className="span-min">Centro Destino</span>
									<AsyncTypeahead
							          	labelKey={(option) => `${option.national_center.name}`}
							          	minLength={0}
							          	name="national_id"
							          	id="national_id"
							          	inputProps={{
							          		name:"national_center_id",
							          		required: true,
							          		id:"national_center_id",
							          		autoComplete:"off",
							          	}}
							          	className="autocomplete-report"
							          	onSearch={this._handleSearch}
							          	placeholder="Búsqueda..."
							          	options={this.state.national_centers}
							          	onChange={this.updateState('national_centers')}
							          	ref={ref => this._typeahead = ref}
							          	useCache={false}
							          	isLoading={this.state.loadHealth}
							          	selectHintOnEnter={true}
							          	//defaultSelected={this.state.health_facilities.slice(this.state.index, 1)}
							          	selected={this.state.national_centers.length > 0 && this.state.index_nc !== -1?
							          		[this.state.national_centers[this.state.index_nc]]
							          		: []}
							          	delay={600}
							          	paginationText="Mostrar mas resultados..."
							        />
								</div>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								<div className="form-group">
									<span className="span-min">Tipo de Salida</span>
									<select className="form-control"  name="option" id="option"
										value={this.state.option} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										<option value="all">TODOS</option>
										{this.state.options.map((l, i)=>{
											return <option key={i} value={l.key}>
												{l.value}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<span className="span-min">Estatus</span>
									<select className="form-control" name="status" id="status" value={this.state.status}
										onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">Todos</option>
										<option value="active">Activo</option>
										<option value="cancel">Cancelado</option>
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">

										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12 form-group" style={{fontSize:"14px"}}>
									<span className="span-min">Total: </span>{' '+this.state.totales}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (GeneralExpenses);